import React from 'react';
import SyncLoader from "react-spinners/SyncLoader";

function Loading(props) {
    return ( 
        <div className='h-0 sticky top-20 md:top-72 z-50'>
            <div className='flex justify-center items-center bg-white bg-opacity-80
                            h-screen md:h-96 mx-4 md:mx-40'>
            <SyncLoader color="#bb16a3"
                        // size={80}
                        speedMultiplier={0.8}
                        loading={props.loading}/>
            </div>
        </div>
     );
}

export default Loading;